// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { IndustryRef } from './industryRef.zod.ts';

export const IdeaPointOut = zod.object({
  "disposition": zod.enum(['active', 'parked', 'archived']),
  "id": zod.uuid(),
  "industry": zod.union([IndustryRef,zod.null()]),
  "research_status": zod.enum(['queued', 'researching', 'scored', 'failed']),
  "scores": zod.record(zod.string(), zod.union([zod.int(),zod.null()])),
  "title": zod.string(),
  "total": zod.union([zod.number(),zod.null()]),
  "verdict": zod.union([zod.enum(['go', 'conditional_go', 'no_go']),zod.null()])
});

export type IdeaPointOut = zod.input<typeof IdeaPointOut>;
export type IdeaPointOutOutput = zod.output<typeof IdeaPointOut>;
